// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!../../../styles/typography.css";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!../../../styles/colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * == BSD2 LICENSE ==
 * Copyright (c) 2016, Tidepool Project
 *
 * This program is free software; you can redistribute it and/or modify it under
 * the terms of the associated License, which is identical to the BSD 2-Clause
 * License as published by the Open Source Initiative at opensource.org.
 *
 * This program is distributed in the hope that it will be useful, but WITHOUT
 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
 * FOR A PARTICULAR PURPOSE. See the License for more details.
 *
 * You should have received a copy of the License along with this program; if
 * not, you can obtain one from Tidepool Project at tidepool.org.
 * == BSD2 LICENSE ==
 */

.CBGTooltip--container--gRocN {
  opacity: 1;
  display: flex;
  flex-direction: column;
  min-width: 80px;
  margin: 2px 0;
  max-width: 180px;
}

.CBGTooltip--row--_jogG {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  line-height: 20px;
}

.CBGTooltip--label--Dy5yz {
  flex-grow: 1;
}

.CBGTooltip--value--XlvA7 {
  margin-left: 20px;
}

.CBGTooltip--units--u0Qbt {
  min-width: 0.7em;
  margin-left: 10px;
}

.CBGTooltip--title--wbHgH {
  text-align: right;
}

.CBGTooltip--bg--NaJsj {
  font-weight: bold;
}

.CBGTooltip--subType--P5spS {
  color: var(--gray-dark);
}

.CBGTooltip--annotation--DMQxi {
}

.CBGTooltip--divider--saPYF {
  height: 3px;
  margin: 5px -10px;
}
`, "",{"version":3,"sources":["webpack://./src/components/daily/cbgtooltip/CBGTooltip.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;EAeE;;AAGF;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,aAAa;EACb,gBAAgB;AAClB;;AAEA;EAEE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EAEE,iBAAiB;AACnB;;AAEA;EAEE,iBAAiB;AACnB;;AAEA;EAEE,uBAAuB;AACzB;;AAEA;AAEA;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB","sourcesContent":["/*\n * == BSD2 LICENSE ==\n * Copyright (c) 2016, Tidepool Project\n *\n * This program is free software; you can redistribute it and/or modify it under\n * the terms of the associated License, which is identical to the BSD 2-Clause\n * License as published by the Open Source Initiative at opensource.org.\n *\n * This program is distributed in the hope that it will be useful, but WITHOUT\n * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS\n * FOR A PARTICULAR PURPOSE. See the License for more details.\n *\n * You should have received a copy of the License along with this program; if\n * not, you can obtain one from Tidepool Project at tidepool.org.\n * == BSD2 LICENSE ==\n */\n@import '../../../styles/colors.css';\n\n.container {\n  opacity: 1;\n  display: flex;\n  flex-direction: column;\n  min-width: 80px;\n  margin: 2px 0;\n  max-width: 180px;\n}\n\n.row {\n  composes: smallSize from '../../../styles/typography.css';\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  line-height: 20px;\n}\n\n.label {\n  flex-grow: 1;\n}\n\n.value {\n  margin-left: 20px;\n}\n\n.units {\n  min-width: 0.7em;\n  margin-left: 10px;\n}\n\n.title {\n  composes: smallSize from '../../../styles/typography.css';\n  text-align: right;\n}\n\n.bg {\n  composes: row;\n  font-weight: bold;\n}\n\n.subType {\n  composes: row;\n  color: var(--gray-dark);\n}\n\n.annotation {\n  composes: subType;\n}\n\n.divider {\n  height: 3px;\n  margin: 5px -10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `CBGTooltip--container--gRocN`,
	"row": `CBGTooltip--row--_jogG ${___CSS_LOADER_ICSS_IMPORT_0___.locals["smallSize"]}`,
	"label": `CBGTooltip--label--Dy5yz`,
	"value": `CBGTooltip--value--XlvA7`,
	"units": `CBGTooltip--units--u0Qbt`,
	"title": `CBGTooltip--title--wbHgH ${___CSS_LOADER_ICSS_IMPORT_0___.locals["smallSize"]}`,
	"bg": `CBGTooltip--bg--NaJsj CBGTooltip--row--_jogG ${___CSS_LOADER_ICSS_IMPORT_0___.locals["smallSize"]}`,
	"subType": `CBGTooltip--subType--P5spS CBGTooltip--row--_jogG ${___CSS_LOADER_ICSS_IMPORT_0___.locals["smallSize"]}`,
	"annotation": `CBGTooltip--annotation--DMQxi CBGTooltip--subType--P5spS CBGTooltip--row--_jogG ${___CSS_LOADER_ICSS_IMPORT_0___.locals["smallSize"]}`,
	"divider": `CBGTooltip--divider--saPYF`
};
export default ___CSS_LOADER_EXPORT___;
